import React from 'react';
import './footer.css';
import { useLocation } from 'react-router-dom';

// Validation Icons
import mcaFeeIcon from 'assets/images/mcafee.png';
import comodoIcon from 'assets/images/comodo.png';
import moneyIcon from 'assets/images/money.png';
import finchIcon from 'assets/images/fincon.png';
import sxswIcon from 'assets/images/sxsw.png';

// Social Media Icons
import instagramIcon from 'assets/images/instagram.svg';
import twitterIcon from 'assets/images/twitter.svg';
import envelopeIcon from 'assets/images/envelope.svg';
import facebookIcon from 'assets/images/facebook.svg';
import { useTranslation } from 'react-i18next';

export default function Footer(props) {
  const { t } = useTranslation();

  const landingsURL = process.env.REACT_APP_LANDINGS_URL;

  const location = useLocation();

  return (
    <>
      <div className="footer">
        <div className="footer-nav nav-footer">
          <div className="nav-footer-container container">
            <div className="nav-footer-row row">
              <div className="nav-footer-col-mobile col col-mobile-50">
                <div className="nav-footer-content">
                  <a className="nav-footer-link" href={`${landingsURL}/about`}>
                    {t('about_title')}
                  </a>
                  <a className="nav-footer-link" href={`${landingsURL}/contact-us`}>
                    {t('footer_contactus_title')}
                  </a>
                  <a
                    className="nav-footer-link"
                    href="mailto:hello@goalsetter.co"
                  >
                    {t('footer_help_title')}
                  </a>
                </div>
              </div>
              <div className="nav-footer-col-mobile col col-mobile-50">
                <div className="nav-footer-content">
                  <a className="nav-footer-link" href={`${landingsURL}/faq`}>
                    {t('footer_faq')}
                  </a>
                  <a className="nav-footer-link" href={`${landingsURL}/terms-of-use`}>
                    {t('footer_tos')}
                  </a>
                  <a className="nav-footer-link" href={`${landingsURL}/privacypolicy`}>
                    {t('footer_privacypolicy_title')}
                  </a>
                </div>
              </div>
              <div className="nav-footer-col col col-25">
                <div className="nav-footer-heading">
                  {t('footer_company_title')}
                </div>
                <div className="nav-footer-content">
                  <a className="nav-footer-link" href={`${landingsURL}/about`}>
                    {t('about_title')}
                  </a>
                </div>
              </div>
              <div className="nav-footer-col col col-25">
                <div className="nav-footer-heading">
                  {t('footer_support_title')}
                </div>
                <div className="nav-footer-content">
                  <a className="nav-footer-link" href={`${landingsURL}/contact-us`}>
                    {t('footer_contactus_title')}
                  </a>
                  <a
                    className="nav-footer-link"
                    href="mailto:hello@goalsetter.co"
                  >
                    {t('footer_help_title')}
                  </a>
                  <a className="nav-footer-link" href={`${landingsURL}/faq`}>
                    {t('footer_faq')}
                  </a>
                </div>
              </div>
              <div className="nav-footer-col col col-25">
                <div className="nav-footer-heading">
                  {t('footer_legal_title')}
                </div>
                <div className="nav-footer-content">
                  <a className="nav-footer-link" href={`${landingsURL}/terms-of-use`}>
                    {t('footer_tos')}
                  </a>
                  <a className="nav-footer-link" href={`${landingsURL}/privacypolicy`}>
                    {t('footer_privacypolicy_title')}
                  </a>
                </div>
              </div>
              <div className="nav-footer-col nav-footer-col-corporate col col-25">
                <div className="nav-footer-heading">
                  {t('footer_corporateoffice_title')}
                </div>
                <div className="nav-footer-content">
                  266 Decatur St, Brooklyn
                  <br />
                  New York, NY 11233, USA
                </div>
              </div>
            </div>
            <div className="nav-footer-share">
              <div className="nav-footer-heading">
                {t('footer_sharewealth_title')}
              </div>
              <div className="nav-footer-socials">
                <a
                  style={{ backgroundImage: `url(${instagramIcon})` }}
                  className="nav-footer-social nav-footer-social-instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/goalsetterco/"
                />
                <a
                  style={{ backgroundImage: `url(${twitterIcon})` }}
                  className="nav-footer-social nav-footer-social-twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/GoalsetterCo"
                />
                <a
                  style={{ backgroundImage: `url(${facebookIcon})` }}
                  className="nav-footer-social nav-footer-social-facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/goalsetterco/"
                />
                <a
                  style={{ backgroundImage: `url(${envelopeIcon})` }}
                  className="nav-footer-social nav-footer-social-envelope"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:info@goalsetter.co"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer">
          <div className="bottom-footer-container container">
            <div className="bottom-footer-row row">
              <div className="bottom-footer-col col col-50 col-tab-100">
                <div className="bottom-footer-copyright">
                  ©
                  {' '}
                  {new Date().getFullYear()}
                  {' '}
                  {t('footer_rights')}
                </div>
                <div className="bottom-footer-trademark">
                  {t('footer_two')}
                  <br/>
                  <br/>
                  {t('footer_three')}
                  <br/>
                  <br/>
                  {t('footer_four')}
                  <br/>
                  <br/>
                  {t('footer_five')}
                  <br/>
                  <br/>
                  {t('footer_investment_advice_description')}
                  <br/>
                  <br/>
                  {t('footer_advice')}
                  <br/>
                  <br/>
                  {location.pathname === '/selectgoalcard' && t('footer_disclaimer')}
                </div>
              </div>
              <div className="bottom-footer-col col col-50 col-tab-100">
                <div className="bottom-footer-partners">
                  <div className="bottom-footer-certified">
                    <div className="bottom-footer-title">
                      {t('footer_certifiedby_title')}
                    </div>
                    <div className="bottom-footer-logos">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="http://home.mcafee.com/store"
                      >
                        <img
                          className="bottom-footer-logo"
                          src={mcaFeeIcon}
                          alt=""
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://ssl.comodo.com"
                      >
                        <img
                          className="bottom-footer-logo"
                          src={comodoIcon}
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                  <div className="bottom-footer-presenter">
                    <div className="bottom-footer-title">
                      {t('footer_presenterat_title')}
                    </div>
                    <div className="bottom-footer-logos">
                      <img
                        className="bottom-footer-logo"
                        src={moneyIcon}
                        alt=""
                      />
                      <img
                        className="bottom-footer-logo"
                        src={finchIcon}
                        alt=""
                      />
                      <img
                        className="bottom-footer-logo"
                        src={sxswIcon}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
